import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {setProgramCurrentStep} from '../../familyMemberCellularSaleSlice';
import {connect} from 'react-redux';
import BtnWhiteBlackBorderSmallSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';

const SuccessOrErrorScreen = ({popUpObj}) => {
  const {
    icon,
    heading,
    secondaryHeading,
    phoneNumber,
    whiteBlackBtn,
    buttonText,
    btnClickedCallBack,
    whiteBlackBigBtnText,
    whiteBlackBigBtnClickedCallBack,
  } = popUpObj;

  useEffect(() => {
    window.scrollTo(0,0);
  }, []);

  return popUpObj ? (
    <div className='success-or-error-screen-idf-family-members-sale'>
      <div className='success-or-error-page-wrapper'>
        {icon && <Image className='success-or-error-page-icon' src={icon} />}

        {heading && <div className='success-or-error-page-heading'>{heading}</div>}

        {secondaryHeading && <div className='success-or-error-page-secondary-heading'>{secondaryHeading}</div>}

        {phoneNumber && <div className='success-or-error-page-phone-number'>{phoneNumber}</div>}

        {whiteBlackBtn?.text && <BtnWhiteBlackBorderSmallSize text={whiteBlackBtn?.text} />}
      </div>
      {buttonText && (
        <BtnSubmit
          text={buttonText}
          onclick={() => {
            if (btnClickedCallBack) {
              btnClickedCallBack();
            }
          }}
        />
      )}
      {whiteBlackBigBtnText && (
        <BtnWhiteBlackBorderBigSize
          text={whiteBlackBigBtnText}
          onclick={() => {
            if (whiteBlackBigBtnClickedCallBack) {
              whiteBlackBigBtnClickedCallBack();
            }
          }}
        />
      )}
    </div>
  ) : null;
};

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = {
  setProgramCurrentStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessOrErrorScreen);
